import { render, staticRenderFns } from "./roleConfig1.vue?vue&type=template&id=2dd2aa74&scoped=true"
import script from "./roleConfig1.vue?vue&type=script&lang=js"
export * from "./roleConfig1.vue?vue&type=script&lang=js"
import style0 from "./roleConfig1.vue?vue&type=style&index=0&id=2dd2aa74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd2aa74",
  null
  
)

export default component.exports